<template>
  <q-dialog v-model="adminHelpTourDialog" transition-show="fade" transition-hide="fade">
    <div class="initialBackDrop" style="min-height: 100vh">
      <div class="q-pa-md q-gutter-sm" style="width: 80ex; margin-left: auto; margin-right: auto; margin-top: 5%; margin-bottom: auto; border-radius: 10px;">
        <q-card style="border-radius: 10px;" class="q-pa-md">
          <q-card-section>
            <q-card-actions align="right" class="text-primary">
              <q-btn icon="close" flat round dense v-close-popup align="right" class="circle-btn" style="margin-bottom: 5px" />
            </q-card-actions>

            <h4 class="helpHeader">Admin View</h4>

            <h6 style="text-align: center; font-weight: 600; margin-bottom: 20px; margin-top: 30px">
              The Admin page has the capability to manage users permissions
              (Access level and Scopes access). Users can be managed at an
              individual level with 'Users' and at a group level with 'User
              Groups'.
            </h6>

            <q-card-actions align="center">
              <div class="q-gutter-md" style="display: flex; flex-direction: column">
                <div style="font-size: 16px; font-weight: bold;">Contact Us: <a href="mailto:FacDocsAdmin@eworldes.com">FacDocsAdmin@eworldes.com</a></div>
                <div align="center">
                  <q-btn flat color="primary" style="font-size: 16px; font-weight: bold;" label="Admin Guide" no-caps type="a" href="./FacDocs Admin Guide.pdf" target="_blank" />
                </div>
              </div>
            </q-card-actions>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import { ref } from 'vue'

export default ({
  setup () {
    const adminHelpTourDialog = ref(false);

    function displayAdminHelpTourDialog() {
      adminHelpTourDialog.value = true;
    }

    return {
      //variables
      adminHelpTourDialog,

      //functions
      displayAdminHelpTourDialog
    }
  }
})
</script>
